import React from "react"

export const Source = ({ text }) => {
  return (
    <div className="text-gray-700 text-sm text-center bg-white mt-2 md:mt-5 px-2 source-text-wrapper mb-5">
      {text}
    </div>
  )
}
